// Athletics Scoring (117) -- public DTOs. Field-of-competitors (no home/away).

export const ATHLETICS_UNITS = ["seconds", "metres", "kilograms"] as const;
export type AthleticsUnit = (typeof ATHLETICS_UNITS)[number];

export interface AthleticsEntryPublic {
  id: string;
  athlete_name: string;
  school_id: string | null;
  school_name: string | null;
  result_value: number | null;
  result_display: string | null;
  attempt_count: number;
  dq: boolean;
  dq_reason: string | null;
  pb: boolean;
  placing: number | null; // computed (null = DQ / no result)
}

export interface AthleticsCompetitionPublic {
  id: string;
  match_id: string;
  discipline: string;
  unit: AthleticsUnit;
  ascending: boolean; // track (timed) ranks ascending; field descending
  wind_assistance: number | null;
  final: boolean;
  entries: AthleticsEntryPublic[];
}

export interface AthleticsScoreResponse {
  match_id: string;
  event_id: string;
  match_name: string;
  competitions: AthleticsCompetitionPublic[];
  _actions: { can_manage: boolean };
}
